module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-share",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('input', {
    ref: "input",
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "title": "Copy"
    },
    on: {
      "click": function($event) {
        _vm.copy()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76fab452!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/share.vue
// module id = 2084
// module chunks = 2